module.exports = __webpack_public_path__ + "img/ljf_icon.22ac77a5.svg";